import React from 'react';
import { IconComponent } from '../atoms/icons/iconComponent';

const iconsId = [
  'user',
  'map',
  'calendar',
  'check',
  'file',
  'cross',
  'alert',
  'edit-circle',
  'video',
  'view360',
  'phone',
  'mail',
  'chat',
  'share',
  'download',
  'tl-dot',
  'tl-dot-sm',
  'open-eye',
  'loyalty',
  'logo-sm',
];
const IconsList = ({ className }) => (
    <ul className={`flex flex-wrap text-center ${className || ''}`}>
      {iconsId.map((icon) => (
        <li key={icon} className="flex flex-col justify-center items-center p-1 m-1 border border-gray-200">
          <div className="text-center font-extrabold text-primary">
            <small className="opacity-50 font-normal">id </small>
            {icon}
          </div>
          <IconComponent icon={icon} key={`options_${icon}`} />
        </li>
      ))}
    </ul>
);

export default IconsList;
